import { Module } from 'vuex';
import { Employee } from '@/shared/model/employee.model';

// eslint-disable-next-line
export const employeeStore: Module<any, any> = {
  state: {
    employee: {} as Employee,
    employeeAuthToken: null as string | null,
  },
  getters: {
    employee: state => state.employee,
    absence: state => state.absence,
    authenticated: state => JSON.stringify(state.employee) !== '{}',
    employeeAuthToken: state => state.employeeAuthToken,
  },
  mutations: {
    setEmployee(state, employee) {
      state.employee = employee;
    },

    setEmployeeImage(state, image) {
      state.employee.image = image;
    },

    setEmployeeAbsence(state, absence) {
      state.absence = absence;
    },

    setEmployeeAuthToken(state, token: string | null) {
      state.employeeAuthToken = token;
    },
  },
  actions: {
    setEmployee({ commit }, employee) {
      commit('setEmployee', employee);
    },
    setEmployeeImage({ commit }, employee) {
      commit('setEmployeeImage', employee);
    },
    setEmployeeAuthToken({ commit }, token: string | null) {
      commit('setEmployeeAuthToken', token);
    },
    logout({ commit }) {
      commit('setEmployee', {});
      commit('setEmployeeAbsence', {});
      commit('setEmployeeAuthToken', null);
    },
  },
};
